import { Component, ElementRef, EventEmitter, Input, Output, ViewChild, inject } from '@angular/core';
import { TradingSessionComponent, UserMessagesComponent } from '@zero/shared/ui-web-components';
import { ButtonComponent } from '@zero/shared/ui-web-design-system';
import { OrderData } from '@zero/shared/util-models';
import { ScrollService, TradingService, UserMessagesHolderService } from '@zero/shared/util-web-app-services';
import { of } from 'rxjs';
import { catchError } from 'rxjs/operators';

@Component({
  selector: 'order-zero-confirm-cancelation',
  templateUrl: './confirm-cancelation.component.html',
  providers: [UserMessagesHolderService],
  imports: [TradingSessionComponent, UserMessagesComponent, ButtonComponent],
})
export class ConfirmCancelationComponent {
  @Input() public orderToCancel: OrderData;
  @Output() public orderCanceled = new EventEmitter();
  @Output() public orderCancelAborted = new EventEmitter();

  public sessionAuthorized: boolean;
  @ViewChild('scrollintoviewElement') public scrollintoviewElement: ElementRef;

  readonly #tradingService = inject(TradingService);
  readonly #messageService = inject(UserMessagesHolderService);
  readonly #scrollService = inject(ScrollService);

  public confirm(): void {
    this.#messageService.clearAllMessages();

    this.#tradingService
      .cancelOrder(this.orderToCancel)
      .pipe(
        catchError((err) => {
          this.#messageService.addErrorMessage(`Fehler bei der Streichung: ${err.error.message}`);
          return of(null);
        }),
      )
      .subscribe((result) => {
        if (result && result.status !== 'fail') {
          this.#messageService.addInfoMessage('Order gestrichen');
          this.orderCanceled.emit(this.orderToCancel);
        }
      });
  }

  public abort(): void {
    this.orderCancelAborted.emit(this.orderToCancel);
  }

  public sessionAuthState(value: boolean): void {
    // we only wanna scroll if sessionAuthorized is not initialized yet,
    // so only for the first change
    if (typeof this.sessionAuthorized === 'undefined') {
      // we need to wait a little until rendering has finished
      setTimeout(() => {
        if (!this.#scrollService.isElementInView(this.scrollintoviewElement)) {
          this.#scrollService.scrollElementIntoView(this.scrollintoviewElement, false);
        }
      }, 100);
    }
    this.sessionAuthorized = value;
  }
}
